import type { Theme } from '@fluentui/react-components';
import {
  teamsDarkTheme as fluentTeamsDarkTheme,
  teamsHighContrastTheme as fluentTeamsHighContrastTheme,
  teamsLightTheme as fluentTeamsLightTheme,
} from '@fluentui/react-components';

import { TeamsColors } from '../../colors/teamsPalette';

import type { CoreUITokenOverrides } from './coreUITokens.types';
import { createCoreUIFluentTheme } from './createFluent9Theme';

export const teamsLightTheme: Theme = createCoreUIFluentTheme(fluentTeamsLightTheme);
export const teamsDarkTheme: Theme = createCoreUIFluentTheme(fluentTeamsDarkTheme);
export const teamsHighContrastTheme: Theme = createCoreUIFluentTheme(fluentTeamsHighContrastTheme);

const lightOverrides: CoreUITokenOverrides = {
  colorBrandAccentForeground: TeamsColors.brand700,
  colorBrandAccentBackground: TeamsColors.fui9ColorBrandBackground2TeamsThemeLight,
  colorBrandAccentBackgroundHover: TeamsColors.fui9ColorBrandBackground2HoverTeamsThemeLight,
};
const darkOverrides: CoreUITokenOverrides = {
  colorBrandAccentForeground: TeamsColors.brand450,
  colorBrandAccentBackground: TeamsColors.fui9ColorBrandBackground2TeamsThemeDark,
  colorBrandAccentBackgroundHover: TeamsColors.fui9ColorBrandBackground2HoverTeamsThemeDark,
};

type GetCoreUITokenOverridesForTeams = (isInverted: boolean) => CoreUITokenOverrides;
export const getCoreUITokenOverridesForTeams: GetCoreUITokenOverridesForTeams = (isInverted) =>
  isInverted ? darkOverrides : lightOverrides;
